import { Box } from '@ethings/ui-toolkit';
import chroma from 'chroma-js';
import { FC, ReactNode } from 'react';

interface ClusterProps {
  size?: number;
  content?: ReactNode;
  color?: string;
  textColor?: string;
}

export const Cluster: FC<ClusterProps> = ({ size = 32, content, color = '#000', textColor = '#fff' }) => {
  return <Box style={{ position: 'relative', width: size, height: size, borderRadius: '50%', backgroundColor: chroma(color).alpha(0.5).hex() }}>
    <Box style={{ color: textColor, display: 'flex', position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: '70%', height: '70%', borderRadius: '50%', backgroundColor: color }}>
      {content && <Box style={{ flexGrow: 1, textAlign: 'center', alignContent: 'center' }}>{content}</Box>}
    </Box>
  </Box>;
};
